export default __webpack_public_path__ + "static/char-s-35-zh-Hans-fbc75fa5d23d87fb5ceff8cbec745466.webp";